import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';

class CompanyProfileRoute extends Route {
  @service router;
  @service session;

  get queryParams() {
    return {
      section: {
        replace: true,
      }
    }
  }

  /** @inheritDoc */
  beforeModel() {
    if (this.session.currentUser.isSeller) {
      this.router.replaceWith(EMBER_ROUTE_NAMES.COMPANY_VIEW);
      return;
    }
  }

  /** @inheritDoc */
  async model() {
    const controller = this.controllerFor('company-profile.index');
    const { companyId } = this.paramsFor('company-profile');

    const [company, postings] = await Promise.all([
      controller.loadCompany(companyId),
      controller.loadPostings(companyId),
    ]);

    return {
      company,
      postings,
    };
  }

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/company/:id/');
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      // Reset the state for the buyer controller upon exiting this route namespace
      const companyProfileController = this.controllerFor('company-profile.index');
      companyProfileController.cancelTasks();

      companyProfileController.setProperties({
        isSavingEditedNoteMap: {},
        isEditingNoteMap: {},
      });
    }
  }
}

export default CompanyProfileRoute;
